/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * Transaction type
 */
export type GetUserAccountTransactionsForAppResponseDataItemEntryType = typeof GetUserAccountTransactionsForAppResponseDataItemEntryType[keyof typeof GetUserAccountTransactionsForAppResponseDataItemEntryType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserAccountTransactionsForAppResponseDataItemEntryType = {
  CREDIT: 'CREDIT',
  DEBIT: 'DEBIT',
} as const;
